var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6172 2.7793H4.38266C3.18945 2.7793 2.22217 3.74658 2.22217 4.93979V17.7793L2.22549 17.8424C2.27373 18.2947 2.8358 18.5069 3.17056 18.1721L6.21717 15.1249L15.6172 15.125C16.8104 15.125 17.7777 14.1577 17.7777 12.9645V4.93979C17.7777 3.74658 16.8104 2.7793 15.6172 2.7793ZM4.38266 3.89041H15.6172C16.1968 3.89041 16.6666 4.36023 16.6666 4.93979V12.9645C16.6666 13.544 16.1968 14.0139 15.6172 14.0139H5.9876L5.91458 14.0187C5.79419 14.0346 5.68159 14.0898 5.59476 14.1766L3.33328 16.4376V4.93979C3.33328 4.36023 3.8031 3.89041 4.38266 3.89041Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0a5a528d4a92361a35da8a0ce995bf5a.svg";
export { ForwardRef as ReactComponent };